import React from 'react'
import { useSearchParams } from 'react-router-dom'
import * as Api from 'src/api'
import { useApi } from 'src/helpers/hooks'
import { useAuthenticatedHeaders } from 'src/hooks/auth/app'
import { useActiveSemester } from 'src/hooks/semesters'
import Select from 'src/views/components/Select'

export default function PortfolioSemesterSelect() {
  const activeSemester = useActiveSemester()
  const [searchParams, setSearchParams] = useSearchParams({
    semId: activeSemester?.id as string,
  })
  const semId = searchParams.get('semId')
  const headers = useAuthenticatedHeaders()

  const { data: semesters, isValidating: isValidatingSemesters } = useApi({
    endpoint: Api.getAdministratorPortfolioListsPortfolioSemesters,
    params: React.useMemo(() => ({ headers }), [headers]),
  })

  const selectedSemester = React.useMemo(
    () => semesters?.items?.filter((semester) => semester.id === semId)[0],
    [semId, semesters]
  )
  return (
    <Select
      className="my-2 mr-2 w-full sm:w-[70%] xxs:max-w-full xs:max-w-full"
      value={selectedSemester}
      options={semesters?.items ?? []}
      getOptionValue={(option) => option.id}
      getOptionLabel={(option) => option.text}
      onChange={(option) => setSearchParams({ semId: option!.id })}
      isDisabled={isValidatingSemesters}
    />
  )
}
